/* eslint-disable camelcase */
import { useState } from 'react'

// import opened_row_arrow from '../../assets/svgs/opened_row_arrow.svg'
import { Minus, Plus } from '../Icons'
import { InfoCoverage } from '../TablePacks/InfoCoverage'
import {
  ButtonContainer,
  PackageTableCell,
  PackageTableCellCoverage,
  PackageTableCellTitle,
  PackageTableRow,
  PackageTableTypeText,
} from '../TablePacks/styles'
import { TextWrap } from './styles'

type Props = {
  isOpened?: boolean
  title: string
  data: any
}

export const CoverageRow = ({ isOpened = false, title, data }: Props) => {
  const [coverageShow, setCoverageShow] = useState(isOpened)

  return (
    <>
      <PackageTableRow>
        <PackageTableCellCoverage whiteBackground>
          <PackageTableCellTitle>
            <PackageTableTypeText>{title}</PackageTableTypeText>
          </PackageTableCellTitle>
        </PackageTableCellCoverage>
        <PackageTableCell whiteBackground>
          <div className="rowCoverage">
            <ButtonContainer onClick={() => setCoverageShow((prev) => !prev)}>
              {coverageShow ? <Minus /> : <Plus />}
            </ButtonContainer>
          </div>
        </PackageTableCell>
      </PackageTableRow>

      {coverageShow && (
        <>
          {data?.map((item: any, index: number) => (
            <PackageTableRow key={index}>
              <PackageTableCell>
                <div className="rowPack">
                  <TextWrap>{item.name}</TextWrap>
                </div>
              </PackageTableCell>
              <PackageTableCell>
                <div className="infoCoverage">
                  <InfoCoverage
                    isDisabled
                    isMandatory={item.mandatory}
                    coverageId={item.coverageId}
                    hasCoverage={item}
                  />
                </div>
              </PackageTableCell>
            </PackageTableRow>
          ))}
        </>
      )}
    </>
  )
}
